import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/contents/conditions/depression")({
  component: LayoutComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression treatment options at Neuro Wellness TMS in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for treatment-resistant.",
        },
        {
          property: "og:title",
          content: "Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression treatment options at Neuro Wellness TMS in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for treatment-resistant.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/conditions/depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [],
    };
  },
});
function LayoutComponent() {
  return <Outlet />;
}
